import Foundation from 'foundation-sites';
window.$ = jQuery;
$(document).foundation();

$(window).on('load', function() {
	// this just adds a class to layout builder elements so we can remove the extra padding and such to make the page look like the final product if want
	const layout_builder = $('#page.layout_builder');
	const hide_class = 'hide-layout-builder-ui';
	if (layout_builder.length > 0){
		const hide_ui_checkbox = layout_builder.find('.js-form-item-hide-layout-builder-ui input');
		if (hide_ui_checkbox.length > 0 ){
			hide_ui_checkbox.change(e=>{
				const checked = e.target.checked;
				if (checked){
					layout_builder.addClass(hide_class);
				} else {
					layout_builder.removeClass(hide_class);
				}
			})
		}

	}

	// just adds the current breakpoint to the body tag
	$('body').attr('data-breakpoint', Foundation.MediaQuery.current);
	$( window ).resize(()=>{
		$('body').attr('data-breakpoint', Foundation.MediaQuery.current);
	});

	/**
	// let see if we can change the background color of the mobile menu
	const drilldown = $('#page #mobile-menu, #mobile-menu .drilldown .is-drilldown-submenu');
	if (drilldown.length > 0 && $('[data-menu-bg-color]').length > 0){
		$(document).on('open.zf.drilldown', function(e) {
			if ($('.is-drilldown-submenu-parent a').length > 0) {
				// get clicked item in the event
				const el = $(e.currentTarget.activeElement);
				// check if we are entering an item with special color
				if (el.parent(). hasClass('root-item')){
					// get the color
					const color = el.closest('[data-menu-bg-color][aria-expanded="true"]').data('menu-bg-color');
					if (color){
						// set the color
						drilldown.css('background-color',color);
					}
				}

			}
		});
		if ($('.js-drilldown-back a').length > 0) {
			$('.js-drilldown-back a').click(function(e) {
				const el = $(e.target);
				if (el.closest('ul').parent().hasClass('root-item')){
					// if this back button is a direct child of a root item then lets remove special colors
					drilldown.attr('style','');
				}
			});
		}
	}
	**/
});
